@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  border-radius: 4px;
  border: 1px solid @cost-review-item--container--border-color;
  background-color: @cost-review-item--container--background-color;
}
